import { AlertCircle, Info } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export const FormAlert = ({ tone = 'error', children }: { tone?: 'error' | 'info'; children: ReactNode }) => (
  <div
    role={tone === 'error' ? 'alert' : 'status'}
    className={cn(
      'flex items-start gap-2 rounded-md border px-3 py-2.5 text-sm',
      tone === 'error' ? 'border-danger/30 bg-danger/5 text-danger' : 'border-brand-teal/30 bg-brand-teal/5 text-brand-teal',
    )}
  >
    {tone === 'error' ? <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden /> : <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />}
    <span>{children}</span>
  </div>
);
